// import React, { useState, useEffect } from "react";

// const ImageSlider = ({ images, interval = 3000 }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);

//     useEffect(() => {
//         const timer = setInterval(() => {
//             setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//         }, interval);

//         return () => clearInterval(timer); // Cleanup the timer on component unmount
//     }, [images, interval]);

//     return (
//         <div className="relative w-full max-w-4xl mx-auto">
//             <div className="overflow-hidden rounded-lg shadow-lg">
//                 {images.map((image, index) => (
//                     <div
//                         key={index}
//                         className={`absolute inset-0 transition-transform duration-700 ease-in-out ${index === currentIndex ? "translate-x-0" : "-translate-x-full"
//                             }`}
//                         style={{
//                             backgroundImage: `url(${image})`,
//                             backgroundSize: "cover",
//                             backgroundPosition: "center",
//                             height: "300px",
//                         }}
//                     ></div>
//                 ))}
//             </div>
//             <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
//                 {images.map((_, index) => (
//                     <button
//                         key={index}
//                         className={`w-3 h-3 rounded-full transition-colors duration-300 ${index === currentIndex ? "bg-blue-500" : "bg-gray-300"
//                             }`}
//                         onClick={() => setCurrentIndex(index)}
//                     />
//                 ))}
//             </div>
//         </div>
//     );
// };



// export default ImageSlider;

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = ({ images, sliderSettings = {} }) => {
    const defaultSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        ...sliderSettings, // Allow overriding defaults
    };

    return (
        <Slider {...defaultSettings}>
            {images.map((image, index) => (
                <div key={index} className="w-full">
                    <img
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className="rounded-lg shadow-lg w-full object-fit"
                        style={{
                            height: "100%",
                            maxHeight: "600px", // Adjust for smaller screens
                        }}
                    />
                </div>
            ))}
        </Slider>
    );
};

export default ImageSlider;
